import React from "react";
import { Box, Paper } from "@mui/material";

interface TabletLayoutProps {
  title?: string;
  children: React.ReactNode;
  fullBleed?: boolean;
}

const TabletLayout: React.FC<TabletLayoutProps> = ({
  title,
  children,
  fullBleed = false,
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "calc(100vh - 64px)",
        px: fullBleed ? 0 : 2,
        py: fullBleed ? 0 : 1.5,
        boxSizing: "border-box",
        backgroundColor: "#f4f6fa",
      }}
    >
      {title && (
        <Paper
          elevation={0}
          sx={{
            p: 1.5,
            mb: 1.5,
            borderRadius: 2,
            fontSize: "1.1rem",
            fontWeight: 600,
            color: "#0d1b2a",
            backgroundColor: "#ffffff",
            border: "1px solid #e3e8ef",
          }}
        >
          {title}
        </Paper>
      )}
      <Box
        sx={{
          width: "100%",
          overflowX: "auto",
          fontSize: "0.92rem",
          "& .MuiTable-root, & table": { fontSize: "0.85rem" },
          "& .MuiButton-root": { fontSize: "0.88rem", minHeight: 40 },
          "& h1": { fontSize: "1.4rem" },
          "& h2": { fontSize: "1.25rem" },
          "& h3": { fontSize: "1.1rem" },
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default TabletLayout;
